export interface SuccessStories {
  name: string;
  image: string;
  firstRow: string;
  lowerMark: string;
  higherMark: string;
  secondRow: string;
}

export const successStories: SuccessStories[] = [
  {
    name: 'Aarti',
    image: 'girl-1',
    firstRow:
      'Aarti is one of our brightest minds. She came to us seeking help to get into her dream college. Aarti excelled in a lot of areas, but she needed special attention in problem-solving. We made sure Aarti was mentored and paid attention to personally in the areas that she needs help. Aarti went on to score from ',
    lowerMark: '1220 in PSAT',
    higherMark: '1520 in SAT',
    secondRow:
      'Aarti says, "Although the classes are in small group settings, everyone\'s voice and questions are heard and addressed, making it very personal to me."',
  },
  {
    name: 'Ryan',
    image: 'boy-1',
    firstRow:
      'Ryan was seeking help to improve his SAT scores and being already one of the smartest; all we needed to do for Ryan was to help him improve his strategy and approach towards solving problems. With our personalized tutoring, step by step, he went from a score of ',
    lowerMark: '1300 in PSAT',
    higherMark: '1590 in SAT',
    secondRow:
      'Ryan feels, “Ravi and team guided me to approach with a different mindset and sharpen my focus. I started seeing the results I had hoped to see. This effect spread beyond my SAT’s to my school grades as well.”',
  },
  {
    name: 'Sameer',
    image: 'boy-2',
    firstRow:
      'We at Ravi’s Academy believe that mastering fundamentals are the key to success in any prep test. When Sameer approached us, our tutors ensured that he doesn’t learn shortcuts to solve problems and understand the basics. Ravi gave him the confidence to resolve and work through all kinds of problems, and he went on to score from ',
    lowerMark: '28 in ACT',
    higherMark: '35 in ACT',
    secondRow:
      'In his words, “Ravi’s  teachings on manipulating and working through logic problems and other math problems were invaluable to me, and I still utilize the skills he taught me to this day in college.”',
  },
  {
    name: 'Srivani',
    image: 'girl-2',
    firstRow:
      "Irrespective of the tutoring formats that our students choose, we at Ravi's Academy believe that each student is unique, and each of them needs special attention. Srivani, like many other students, had her strengths and needs that were to be addressed. Our tutors ensure she plays to her strengths, and she went to a score from ",
    lowerMark: '1250 in PSAT',
    higherMark: '1550 in SAT',
    secondRow:
      'In her own words, "Ravi\'s Academy goes out of their way to ensure every student understands the solution to every problem."',
  },
];
